import { AssistantCatHomeAction } from "@/constants/assistantCatHome";
import { AssistFunctionType } from "@/lib/models/assist";

export type AssistantCatHomeManuscriptRequestType = "feedback" | "matching" | "catchcopy" | "summary" | "themeGenerate";

export type AssistantCatHomeRequestStep = "work" | "manuscript" | "theme";

export type AssistantCatHomeAssistTab = "request" | "history";

export type AssistantCatHomeThemeKind = "feedback" | "matching";

export function assistantCatHomeRequestTitleKey(action: AssistantCatHomeAction): string {
  return `assistantCatHome.menu.${action}`;
}

export function assistantCatHomeWorkSelectPromptKey(action: AssistantCatHomeAction): string {
  return `assistantCatHome.workSelect.prompt.${action}`;
}

export function assistantCatHomeManuscriptRequestType(
  action: AssistantCatHomeAction
): AssistantCatHomeManuscriptRequestType | null {
  switch (action) {
    case "feedbackManuscript":
      return "feedback";
    case "generateSummary":
      return "summary";
    case "catchcopy":
      return "catchcopy";
    case "matchingNovelAndCompany":
      return "matching";
    case "generateTheme":
      return "themeGenerate";
    default:
      return null;
  }
}

export function assistantCatHomeThemeKind(action: AssistantCatHomeAction): AssistantCatHomeThemeKind | null {
  if (action === "feedbackTheme") {
    return "feedback";
  }
  if (action === "matchingTheme") {
    return "matching";
  }
  return null;
}

export function assistantCatHomeFunctionType(action: AssistantCatHomeAction): AssistFunctionType | null {
  switch (action) {
    case "feedbackManuscript":
      return AssistFunctionType.FEEDBACK_MANUSCRIPT;
    case "generateSummary":
      return AssistFunctionType.GENERATE_SUMMARY;
    case "catchcopy":
      return AssistFunctionType.GENERATE_CATCHCOPY;
    case "matchingNovelAndCompany":
      return AssistFunctionType.MATCHING_COMPANY;
    case "generateTheme":
      return AssistFunctionType.GENERATE_THEME;
    case "feedbackTheme":
      return AssistFunctionType.FEEDBACK_THEME;
    case "matchingTheme":
      return AssistFunctionType.MATCHING_THEME;
    default:
      return null;
  }
}
